exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-config-linked-label[data-v-6508f8fa] {\n  font-size: 12px;\n  color: #909399;\n  line-height: 1.4;\n}\n", ""]);

// exports
